import { render, staticRenderFns } from "./alarm-handling.vue?vue&type=template&id=8bf48e6c"
import script from "./alarm-handling.vue?vue&type=script&lang=js"
export * from "./alarm-handling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports